import constantes from '../helpers/constanteHelper'

import Form from 'react-bootstrap/Form'
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import iconeHint from '../images/hint.svg'

function FiltrosProdutosProdutoSustentavel({ setTipoVisualizacao, temas = [], especies = [], categorias = [], aplicarFiltros, filtroTema, setFiltroTema, filtroEspecie, setFiltroEspecie, filtroCategoria, setFiltroCategoria, resolucaoMobile }) {

    return (
        <Form style={{ gap: '20px' }} className=' mb-5 d-flex flex-wrap justify-content-center align-items-center' noValidate id='form-cadastro'>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Tipo de visualização</Form.Label>
                <Form.Select
                    defaultValue={'Por empresa'}
                    onChange={(e) => {
                        setTipoVisualizacao(e.target.value)
                    }}
                >
                    <option key={'Por tema'} value={'Por tema'}>Por capítulo</option>
                    <option key={'Por empresa'} value={'Por empresa'}>Por empresa</option>
                    <option key={'Por espécie'} value={'Por espécie'}>Por espécie</option>
                    <option key={'Por categoria'} value={'Por categoria'}>Por categoria</option>
                </Form.Select>
            </Form.Group>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <div className='mb-2 d-flex align-items-center justify-content-start'>
                    <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO, margin: 0 }} className='fw-bold'>Filtro por capítulo</Form.Label>
                    <OverlayTrigger placement="top"
                        overlay={<Tooltip>
                            {'O capítulo é a classificação geral dos produtos avaliados pelo protocolo da certificação de Produto Sustentável.'}
                        </Tooltip>}>
                        <img className='ms-2' height={18} src={iconeHint} alt="dica" />
                    </OverlayTrigger>
                </div>
                <Form.Select
                    onChange={(e) => {
                        setFiltroTema(e.target.value)
                        aplicarFiltros(e.target.value, filtroEspecie, filtroCategoria)
                    }}
                >
                    <option value={''}></option>
                    {temas.map((tema) => <option key={tema} value={tema}>{tema}</option>)}

                </Form.Select>
            </Form.Group>

            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Filtro por espécie</Form.Label>
                <Form.Select
                    onChange={(e) => {
                        setFiltroEspecie(e.target.value)
                        aplicarFiltros(filtroTema, e.target.value, filtroCategoria)
                    }}
                >
                    <option value={''}></option>
                    {especies.map((especie) => <option key={especie} value={especie}>{especie?.replaceAll(' - Peixes', '')}</option>)}

                </Form.Select>
            </Form.Group>

            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO }} className='fw-bold'>Filtro por categoria</Form.Label>
                <Form.Select
                    onChange={(e) => {
                        setFiltroCategoria(e.target.value)
                        aplicarFiltros(filtroTema, filtroEspecie, e.target.value)
                    }}
                >
                    <option value={''}></option>
                    {categorias.map((categoria) => <option key={categoria} value={categoria}>{categoria}</option>)}

                </Form.Select>
            </Form.Group>
        </Form>
    );
}
export default FiltrosProdutosProdutoSustentavel;
